import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { contiCorrenti, enableContoCorrente, disableContoCorrente, deleteContoCorrente } from "../../../api/contoCorrenteApi"

export default function* contoCorrenteSaga() {
    yield all([
        fork(watchFetchContoCorrenteRequest),
        fork(watchEnableContoCorrenteRequest),
        fork(watchDisableContoCorrenteRequest),
        fork(watchDeleteContoCorrenteRequest),
    ]);
}

function* watchFetchContoCorrenteRequest() {
    yield takeLatest(
        actions.FETCH_CONTO_CORRENTE_REQUEST,
        fetchContoCorrenteRequest
    )
}

function* fetchContoCorrenteRequest() {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(contiCorrenti)
        yield put({ type: actions.FETCH_CONTO_CORRENTE_SUCCESS, contiCorrenti: data })
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_CONTO_CORRENTE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}

function* watchEnableContoCorrenteRequest() {
    yield takeLatest(
        actions.ENABLE_CONTO_CORRENTE_REQUEST,
        enableContoCorrenteRequest
    )
}

function* enableContoCorrenteRequest(contoCorrenteData) {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(enableContoCorrente,contoCorrenteData.value.idBank, contoCorrenteData.value)
        yield put({ type: actions.ENABLE_CONTO_CORRENTE_SUCCESS, contiCorrenti: data })
        let corporateData={corporate:contoCorrenteData.value.corporate,bankId:contoCorrenteData.value.idBank}
        yield put({ type: actions.FETCH_CORPORATE_EDIT_REQUEST, value: corporateData })
        //yield put(push(`/corporate/edit/${contoCorrenteData.value.corporate}`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.ENABLE_CONTO_CORRENTE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}

function* watchDisableContoCorrenteRequest() {
    yield takeLatest(
        actions.DISABLE_CONTO_CORRENTE_REQUEST,
        disableContoCorrenteRequest
    )
}

function* disableContoCorrenteRequest(contoCorrenteData) {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(disableContoCorrente,contoCorrenteData.value.idBank, contoCorrenteData.value)
        yield put({ type: actions.DISABLE_CONTO_CORRENTE_SUCCESS, contiCorrenti: data })
        let corporateData={corporate:contoCorrenteData.value.corporate,bankId:contoCorrenteData.value.idBank}
        yield put({ type: actions.FETCH_CORPORATE_EDIT_REQUEST, value: corporateData })
        //yield put(push(`/corporate/edit/${contoCorrenteData.value.corporate}`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.DISABLE_CONTO_CORRENTE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}

function* watchDeleteContoCorrenteRequest() {
    yield takeLatest(
      actions.DELETE_CONTO_CORRENTE_REQUEST,
      deleteContoCorrenteRequest
    )
}

function* deleteContoCorrenteRequest(contoCorrenteData) {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(deleteContoCorrente,contoCorrenteData.value.idBank, contoCorrenteData.value)
        yield put({ type: actions.DELETE_CONTO_CORRENTE_SUCCESS, contiCorrenti: data })
        let corporateData={corporate:contoCorrenteData.value.corporate,bankId:contoCorrenteData.value.idBank}
        yield put({ type: actions.FETCH_CORPORATE_EDIT_REQUEST, value: corporateData })
        //yield put(push(`/corporate/edit/${contoCorrenteData.value.corporate}`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.DELETE_CONTO_CORRENTE_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}